export default __webpack_public_path__ + "static/media/article1.2f4d68eb.png";